import styled from "styled-components";
import { Checkbox } from "antd";
import {
    BulletListIcon,
    HistoryIcon,
    LogoMainIcon,
    LogOutIcon,
    QuotesIcon,
    SettingsIcon,
    TabsIcon,
    TabsSettingsIcon,
    TrashIcon,
} from "../../assets/images";

export const SideMenu = styled.div`
    width: 44px;
    height: 100vh;
    position: fixed;
    z-index: 9999;
    overflow: visible;
    box-shadow: 0 0 5px rgba(49, 69, 49, 0.14);
    background-color: ${(props) => props.theme.bg.default};
`;

export const LeftWrapper = styled(SideMenu)`
    top: 0;
    left: 0;
    border-radius: 0 10px 10px 0;
`;

export const RightWrapper = styled(SideMenu)`
    top: 0;
    right: 0;
    border-radius: 10px 0 0 10px;
    z-index: 100;
`;

export const Icons = styled.div`
    display: flex;
    flex-direction: column;

    .selected {
        box-shadow: inset 2px 3px 3px rgba(0, 0, 0, 0.29);
        background-color: #629361;

        svg {
            filter: brightness(1000%);
        }
    }

    > div,
    svg {
        cursor: pointer;
    }
`;

export const LogsIconWrapper = styled.div`
    padding: 13px;
`;

export const RightIcons = styled(Icons)`
    .selected {
        box-shadow: none;
    }

    > div,
    svg {
        cursor: pointer;
    }
`;

export const Icon = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid rgba(98, 147, 97, 0.15);
    min-height: 44px;
    cursor: pointer;
    position: relative;
    background-color: #ffffff;
    :nth-child(1) {
        min-height: 63px;
        cursor: pointer;
    }
`;

export const IconWrapper = styled.div`
    position: relative;
`;

export const CustomLogoMainIcon = styled(LogoMainIcon)`
    height: 30px;
`;

export const CustomHistoryIcon = styled(HistoryIcon)`
    cursor: pointer;
`;
export const CustomLogOut = styled(LogOutIcon)`
    cursor: pointer;
`;

export const CustomQuotesIcon = styled(QuotesIcon)`
    cursor: pointer;
`;

export const CustomSettingsIcon = styled(SettingsIcon)`
    cursor: pointer;
`;

export const CustomTabsSettingsIcon = styled(TabsSettingsIcon)`
    cursor: pointer;
`;

export const CustomTabsIcon = styled(TabsIcon)`
    cursor: pointer;
`;

export const CustomTrashIcon = styled(TrashIcon)`
    cursor: pointer;
`;

export const CustomBulletListIcon = styled(BulletListIcon)`
    cursor: pointer;
`;

export const CustomAntCheckbox = styled(Checkbox)`
    .ant-checkbox-checked .ant-checkbox-inner {
        background-color: ${({ theme }) => theme.color.settingsBackground};
        border-color: #47592f;
        border-width: 1.8px;
    }

    .ant-checkbox-checked .ant-checkbox-inner:after {
        border-color: #ffffff !important;
    }

    .ant-checkbox-wrapper:hover .ant-checkbox-inner,
    .ant-checkbox-checked:hover .ant-checkbox-inner,
    .ant-checkbox:hover .ant-checkbox-inner,
    .ant-checkbox-input:focus + .ant-checkbox-inner {
        border: 1.8px solid #ffffff !important;
    }
`;

export const VirtButton = styled.div`
    height: 200px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    user-select: none;
    background-color: #7cbe7b;
    color: #fff;
    border-bottom: 1px solid rgba(98, 147, 97, 0.15);
    border-top: 1px solid rgba(98, 147, 97, 0.15);
    margin-top: 100px;
    font-size: 25px;
    flex-direction: column;
    transition: background-color 0.3s ease;
    padding: 110px 0;

    &:hover {
        background-color: #629361;
    }
`;
